export const ReactJs = [
    {
      question: "What is React?",
      option1: "A programming language",
      option2: "A JavaScript library for building user interfaces",
      option3: "A database management system",
      option4: "A server-side framework",
      ans: 2,
    },
    {
      question: "What are components in React?",
      option1: "Functions that return HTML elements",
      option2: "Files that store CSS styles",
      option3: "Modules that define routing rules",
      option4: "Independent, reusable pieces of UI",
      ans: 4,
    },
    {
      question: "What is JSX in React?",
      option1: "A data fetching library",
      option2: "A syntax extension for JavaScript",
      option3: "A testing framework",
      option4: "A state management tool",
      ans: 2,
    },
    {
      question: "How do you pass data to a child component in React?",
      option1: "Using refs",
      option2: "Using props",
      option3: "Using state",
      option4: "Using context",
      ans: 2,
    },
    {
      question: "What is state in React?",
      option1: "Data that never changes",
      option2: "Data passed from parent components",
      option3: "An object that holds component's data",
      option4: "An array that stores component's functions",
      ans: 3,
    },
    {
      question: "What are lifecycle methods in React?",
      option1: "Methods that execute when a component is created",
      option2: "Methods that execute when a component is updated or destroyed",
      option3: "Methods that handle data fetching",
      option4: "Methods that handle event listeners",
      ans: 2,
    },
    {
      question: "What is React Router?",
      option1: "A state management library",
      option2: "A module bundler",
      option3: "A routing library for React applications",
      option4: "A testing utility",
      ans: 3,
    },
    {
      question: "What is Redux in React?",
      option1: "A testing framework",
      option2: "A state management library",
      option3: "A database management system",
      option4: "A server-side framework",
      ans: 2,
    },
    {
      question: "How do you handle forms in React?",
      option1: "Using form tags",
      option2: "Using event listeners",
      option3: "Using controlled components",
      option4: "Using form libraries",
      ans: 3,
    },
    {
      question: "What is the purpose of useEffect() hook in React?",
      option1: "To manage component state",
      option2: "To perform side effects in function components",
      option3: "To fetch data from the server",
      option4: "To define routing rules",
      ans: 2,
    },
  ];
  